<template>
    <div class="contactUs_wrap">
      <Header/>
      <section class="warp">
        <div class="title">
          <span class="line_left line">
            <img :src="leftImg">
          </span>
          <h3>联系我们</h3>
          <span class="line_right line">
            <img src="../assets/goldRight.png">
          </span>
        </div>
        <div class="content">
          <div class="part1">
            <p style="text-indent: 0"> 电话：010-84784865</p>
            <p style="text-indent: 0"> 联系邮箱：yingrongda@yingrongda.com</p>
          </div>
        </div>
      </section>
      <Footer/>
    </div>
</template>
<script>
  import Header from './header'
  import leftImg from '../assets/goldLeft .png'
  import Footer from './footer'
    export default {
        name: 'contactUs',
        components: {
          Header,
          Footer
        },

        props: {},

        data() {
            return {
              leftImg
            }
        },

        computed: {},

        watch: {},

        created() {
        },

        mounted() {
        },

        destroyed() {
        },

        methods: {}
    }
</script>

<style scoped lang="scss">
  .contactUs_wrap{
    height: 100%;

    .warp{
      padding-top: 5.625rem;
      width: 40%;
      height: 80%;
      margin: auto;
      .title{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        text-align: center;
        position: relative;
        .line_left,.line_right{
          display: inline-block;
          position: absolute;
          top: 50%;
        }
        .line{
          width: 75px;
          height: 20px;
          line-height: 20px;
          margin-top: -10px;
        }
        h3{
          display: inline-block;
          color: #555;
          text-align: center;
        }
        img{
          width: 100%;
          vertical-align: middle;
        }
      }
        .content{
          color: #666;
          text-align: justify;
          p{
            margin: 0 0 10px;
          }
        }
      }
  }
  @media screen and (min-width: 768px) {
    .line_left{
      left: 60px;
    }
    .line_right{
      right: 60px;
    }
    .line{
      width: 75px;
      height: 20px;
      line-height: 20px;
      margin-top: -10px;
    }
    h3{
      font-size: 30px;
      margin: 70px 50px;
    }

    .content{
      text-align: justify;
      -ms-text-justify: inter-ideograph;
      text-justify: inter-ideograph;
      text-spacing: ideograph-alpha;
      font-size: 14px;
      line-height: 32px;
      text-indent: 32px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/contactUs.vue